import templateStr from 'text!./cpp-building-header.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            displayName: '&',
            locationId: '&',
            buildingId: '&',
            isAccordionOpen: '=',
            showActions: '=',
            wide: '&',
            onRemove: '&',
            onEdit: '&'
        },
        controller: function controller($scope) {
            $scope.editBuilding = function () {
                if (typeof $scope.onEdit() === 'function') {
                    $scope.onEdit()();
                }
            };

            $scope.removeBuilding = function () {
                if (typeof $scope.onRemove() === 'function') {
                    $scope.onRemove()();
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/locationsAndBuildings/directives/cpp-building-directive/CPPBuildingHeader.js
// module id = 815
// module chunks = 0